import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.grey2};
`;

const Label = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 400;
  white-space: nowrap;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  line-height: 20px;
  margin: 8px 0;
  background: ${({ theme }) => theme.colors.white};
`;

/**
 * An unread messages divider line.
 *
 * @param {Object} props
 * @param {boolean} [props.compact=false] - Compact mode for side panel
 */
const UnreadDivider = ({ compact = false }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Wrapper $compact={compact}>
      <Line />
      <Label $compact={compact}>{t('help_desk_unread_messages')}</Label>
      <Line />
    </Wrapper>
  );
};

export default UnreadDivider;
